<template>
  <div>
    <container-headline
      :headline="$t('global.masterdata')"
      :col="6"
    ></container-headline>
    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div class="row">
            <div class="col-xl-4">
              <div class="form-group">
                <ValidationProvider
                  rules="required"
                  immediate
                  v-slot="{ passed }"
                >
                  <input
                    v-model.trim="fach.kuerzel"
                    class="form-control"
                    placeholder=" "
                    v-bind:class="{ 'border-danger': !passed }"
                    :readonly="!editable"
                  />
                  <label v-bind:class="{ 'text-danger': !passed }">
                    {{ $t('global.shortdesignation') }}
                  </label>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-xl-8">
              <div class="form-group">
                <ValidationProvider
                  rules="required"
                  immediate
                  v-slot="{ passed }"
                >
                  <input
                    v-model.trim="fach.bezeichnung"
                    class="form-control"
                    placeholder=" "
                    v-bind:class="{ 'border-danger': !passed }"
                    :readonly="!editable"
                  />
                  <label v-bind:class="{ 'text-danger': !passed }">
                    {{ $t('global.designationsubject') }}
                  </label>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <v-select
                  v-model="fach.veranstaltungsstatus"
                  label="bezeichnung"
                  :options="veranstaltungsstati"
                  :disabled="!editable"
                  :placeholder="$t('global.status')"
                >
                  <span slot="no-options">{{ $t('global.taptosearch') }}</span>
                </v-select>
                <label>{{ $t('global.status') }}</label>
              </div>
            </div>
            <div class="col-xl-6">
              <div class="form-group">
                <v-select
                  v-model="fach.lehrmethode"
                  label="bezeichnung"
                  :options="lehrmethoden"
                  :disabled="!editable"
                  :placeholder="$t('global.teachingmethod')"
                >
                  <span slot="no-options">{{ $t('global.taptosearch') }}</span>
                </v-select>
                <label>{{ $t('global.teachingmethod') }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-4">
              <div class="form-group">
                <v-select
                  v-model="fach.niveau"
                  label="bezeichnung"
                  :options="niveaus"
                  :disabled="!editable"
                  :placeholder="$t('global.level')"
                >
                  <span slot="no-options">{{ $t('global.taptosearch') }}</span>
                </v-select>
                <label>{{ $t('global.level') }}</label>
              </div>
            </div>
            <div class="col-xl-4">
              <div class="form-group">
                <v-select
                  v-model.trim="fach.color"
                  :options="colorOptions"
                  label="label"
                  :reduce="(o) => o.value"
                  :disabled="!editable"
                  :clearable="false"
                  :placeholder="$t('global.color')"
                >
                  <template v-slot:option="opt">
                    <div class="d-flex align-items-center">
                      <span
                        class="color-swatch mr-2"
                        :style="{ backgroundColor: opt.value }"
                      ></span>
                      <span>{{ opt.label }}</span>
                    </div>
                  </template>

                  <template v-slot:selected-option="opt">
                    <div class="d-flex align-items-center">
                      <span
                        class="color-swatch mr-2"
                        :style="{ backgroundColor: opt.value }"
                      ></span>
                      <span>{{ opt.label }}</span>
                    </div>
                  </template>

                  <span slot="no-options">{{ $t('global.taptosearch') }}</span>
                </v-select>
                <label>{{ $t('global.color') }}</label>
              </div>
            </div>
            <div class="col-xl-4">
              <div class="form-group">
                <v-select
                  v-model="fach.fach"
                  :getOptionLabel="
                    (modul) =>
                      (modul.kuerzel ? modul.kuerzel + ' - ' : '') +
                      (modul.bezeichnung || modul.Bezeichnung || '')
                  "
                  :options="faecher"
                  :disabled="!editable"
                  :placeholder="$t('global.module')"
                >
                  <span slot="no-options">{{ $t('global.taptosearch') }}</span>
                </v-select>
                <label>{{ $t('global.module') }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <textarea
                  v-model.trim="fach.beschreibung"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                ></textarea>
                <label>{{ $t('global.description') }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ContainerHeadline from '@/components/ContainerHeadline'

  export default {
    name: 'FachStammdaten',
    components: {
      ContainerHeadline,
    },
    props: {
      isTemplate: {
        type: Boolean,
        required: true,
      },
      fach: {
        type: Object,
        required: true,
      },
      editable: {
        type: Boolean,
        required: true,
      },
      veranstaltungsstati: {
        type: Array,
      },
      lehrmethoden: {
        type: Array,
      },
      niveaus: {
        type: Array,
      },
      faecher: {
        type: Array,
      },
    },
    data() {
      return {
        colorOptions: [
          { label: 'Hellblau', value: '#E3F2FD' },
          { label: 'Eisblau', value: '#E1F5FE' },
          { label: 'Mint', value: '#E0F2F1' },
          { label: 'Türkis hell', value: '#E0F7FA' },
          { label: 'Hellgrün', value: '#E8F5E9' },
          { label: 'Limette hell', value: '#F1F8E9' },
          { label: 'Gelb sehr hell', value: '#FFFDE7' },
          { label: 'Apricot', value: '#FFF3E0' },
          { label: 'Pfirsich', value: '#FFE0B2' },
          { label: 'Rosé', value: '#FCE4EC' },
          { label: 'Flieder', value: '#F3E5F5' },
          { label: 'Lavendel', value: '#EDE7F6' },
          { label: 'Blaugrau', value: '#ECEFF1' },
          { label: 'Beige', value: '#EFEBE9' },
          { label: 'Hellrot', value: '#FFEBEE' },
        ],
      }
    },
    watch: {
      veranstaltungsstati: function (val) {
        if (val && !this.fach.veranstaltungsstatus) {
          let veranstaltungStatusOffen = this.$CONST('VERANSTALTUNGSSTATI').OPEN

          this.fach.veranstaltungsstatus = this.veranstaltungsstati.find(
            ({ id }) => id == veranstaltungStatusOffen
          )
        }
      },
      'fach.veranstaltungsstatus': function (newVal, oldVal) {
        if (!oldVal || !newVal) return
        if (oldVal.id === newVal.id) return
        if (newVal && newVal.id == '174D9067E04') {
          // Abgesagt

          this.$emit('eventCancelled', newVal, oldVal)
        }
      },
      'veranstaltung.color': {
        immediate: true,
        handler(v) {
          if (!v) return
          const norm = v.startsWith('#') ? v : `#${v}`
          this.veranstaltung.color = norm.toUpperCase()
        },
      },
    },
    computed: {},
    mounted: function () {},
    methods: {},
  }
</script>

<style lang="scss">
  .color-swatch {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }
</style>
